import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import XrCardAv from '../../../components/XrCardAv.tsx';
import XrTextAv from '../../../components/XrTextAv.tsx';
import XrInputAv from '../../../components/XrInputAv.tsx';
import XrButtonAv from '../../../components/XrButtonAv.tsx';
import XrDataTable from '../../../components/XrDataTable.tsx';
import styled from 'styled-components';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';

const FormInventory = (props) => {
  const [inventoryQty, setInventoryQty] = useState(0);
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [inventorySelected, setInventorySelected] = useState(null);
  const [errors, setErrors] = useState({
    name: [],
    qty: []
  });

  useEffect(() => {
    const newInventories = [];
    props.burrowedItems.forEach(inventory => {
      const inventoryId = inventory.id_inventory;
      if (inventoryId) {
        newInventories.push(inventory);
      }
    });
    props.setForm({ ...props.form, inventories: newInventories });
  }, [props.burrowedItems])

  useEffect(() => {
    const newOptions = [];
    props.inventories.forEach(item => {
      if (item.id) {
        newOptions.push({
          value: item.id?.toString(),
          label: item.item_name
        });
      }
    });
    setInventoryOptions(newOptions);
  }, [props.inventories]);

  const onChangeSelectedInventory = (e) => {
    setInventorySelected(e);
  }

  const onChangeInventoryQty = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) {
      setInventoryQty(val);
    }
  }

  const actionAddInventoryItem = () => {
    if (props.isLoading) return;

    let hasError = false;
    const newErrors = {...errors};

    if (!inventorySelected) {
      hasError = true;
      newErrors.name = ['Nama inventaris yang ingin dipinjam wajib diisi.'];
    } else {
      newErrors.name = [];
    }
    if (!inventoryQty || isNaN(inventoryQty) || inventoryQty <= 0) {
      hasError = true;
      newErrors.qty = ['Jumlah inventaris yang ingin dipinjam wajib diisi.'];
    } else {
      newErrors.qty = [];
    }

    setErrors(newErrors);

    if (hasError) {
      toast.error('Gagal menambahkan inventaris yang ingin dipinjam.');
      return;
    }

    const inventoryId = parseInt(inventorySelected.value);
    const inventoryDetail = props.inventories.find(i => i.id === parseInt(inventorySelected.value));
    const newOptions = [...props.burrowedItems];
    const previousItemIndex = props.burrowedItems.findIndex(i => i.id_inventory === inventoryId)
    if (previousItemIndex >= 0) {
      newOptions[previousItemIndex].quantity = inventoryQty;
    } else {
      newOptions.push({
        quantity: inventoryQty,
        id_inventory: parseInt(inventorySelected.value),
        inventory_detail: inventoryDetail
      });
    }
    props.setBurrowedItems(newOptions);
    setInventoryQty(0);
    setInventorySelected(null);
  }

  const actionDeleteItem = (index) => {
    const newOptions = [...props.burrowedItems];
    newOptions.splice(index, 1);
    props.setBurrowedItems(newOptions);
  }

  const onChangeItemQty = (e, index) => {
    const qty = parseInt(e.target.value);
    if (!qty || isNaN(qty) || qty <= 0) return;
    const newOptions = [...props.burrowedItems];
    newOptions[index].quantity = qty;
    props.setBurrowedItems(newOptions);
  }

  const actionConfirmInventory = () => {
    const newInventories = [];
    props.burrowedItems.forEach(inventory => {
      newInventories.push({
        id_inventory: inventory.inventory_detail.id,
        quantity: inventory.quantity,
        inventory_detail: inventory.inventory_detail
      });
    });
    props.setForm({ ...props.form, inventories: newInventories });
    props.setCurrentStep('04-identitas-pemohon');
  }

  const renderBurrowedItems = () => {
    if (props.burrowedItems.length > 0)
      return props.burrowedItems.map((item, index) => (
        <tr key={index}>
          <td>{item.inventory_detail?.item_name}</td>
          <td>
            <input
              type='number'
              value={item.quantity}
              className='requestBooking__form__qty'
              onChange={e => onChangeItemQty(e, index)}
            />
          </td>
          <td>
            <XrButtonAv
              noBlock
              color='danger'
              icon={faTrash}
              disabled={props.isLoading}
              isLoading={props.isLoading}
              onClick={() => actionDeleteItem(index)}
            />
          </td>
        </tr>
      ));
    else 
      return (
        <tr>
          <td colSpan={3} style={{ textAlign: "center" }}>Belum ada barang yang dipinjam.</td>
        </tr>
      )
  }

  return (
    <FormInventoryWrapper>
      <XrCardAv>
        <div className="card--title requestBooking__toolbar">
          <div style={{ marginRight: '10px' }}>
            <XrTextAv tag='h2' variant='title'>
              Tambah Peralatan
            </XrTextAv>
            <XrTextAv tag='p' variant='description'>
              Kosongkan apabila tidak ada inventaris yang akan dipinjam.
            </XrTextAv>
          </div>
          <XrButtonAv
            noBlock
            style={{ width: '200px' }}
            size='large'
            caption={`Ubah Ruangan`}
            disabled={props.isLoading}
            isLoading={props.isLoading}
            onClick={() => props.setCurrentStep('02-cari-ruangan')}
          />
        </div>
        <div className="card--body">
          <XrDataTable style={{ margin: 0 }}>
            <div className="tablewrapper--table">
              <table>
                <thead>
                  <tr>
                    <th style={{ minWidth: '207px' }}>Nama</th>
                    <th style={{ minWidth: '166px' }}>Jumlah</th>
                    <th>Tindakan</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <XrInputAv
                        label='Inventaris'
                        required={true}
                        disabled={props.isLoading}
                        isLoading={props.isLoading}
                        placeholder='Cari inventaris'
                        selectProps={{
                          value: inventorySelected,
                          options: inventoryOptions,
                          onChange: onChangeSelectedInventory
                        }}
                        errorMessage={errors.name}
                      />
                    </td>
                    <td>
                      <XrInputAv
                        type='text'
                        required={true}
                        label='Jumlah'
                        errorMessage={errors.qty}
                        disabled={props.isLoading}
                        isLoading={props.isLoading}
                        value={inventoryQty.toString()}
                        onChange={onChangeInventoryQty}
                      />
                    </td>
                    <td>
                      <XrButtonAv
                        noBlock
                        disabled={props.isLoading}
                        isLoading={props.isLoading}
                        onClick={actionAddInventoryItem}
                        icon={faPlus}
                      />
                    </td>
                  </tr>
                  {renderBurrowedItems()}
                </tbody>
              </table>
            </div>
          </XrDataTable>

          <div style={{ marginTop: '15px' }}>
            <XrButtonAv
              noBlock
              size='large'
              color='primary'
              disabled={props.isLoading}
              isLoading={props.isLoading}
              onClick={actionConfirmInventory}
              caption={`Konfirmasi Peminjaman Inventaris`}
            />
          </div>
        </div>
      </XrCardAv>
    </FormInventoryWrapper>
  )
}

const FormInventoryWrapper = styled.div`
  .requestBooking__form__qty {
    max-width: 60px;
    border-radius: 5px;
    padding: 5px 10px 5px 10px;
    border: 1px solid #dedede;
  }
`;

export default FormInventory;